const timer = setInterval(() => {
  document.querySelectorAll('.cd-price-display').forEach((priceDisplay) => {
    const offerPriceElement = priceDisplay.querySelector('.money');
    const originalPriceElement = priceDisplay.querySelector('.cd-original-price');

    if (offerPriceElement && originalPriceElement) {
      const offerPrice = parseFloat(offerPriceElement.textContent.replace(/[₹,]/g, ''));
      const originalPrice = parseFloat(originalPriceElement.textContent.replace(/[₹,]/g, ''));

      if (!isNaN(originalPrice) && !isNaN(offerPrice) && originalPrice > offerPrice) {
        const discountAmount = originalPrice - offerPrice;
        const discountPercentage = Math.round((discountAmount / originalPrice) * 100); // Làm tròn số nguyên

        // Kiểm tra xem đã có phần tử giảm giá chưa, tránh tạo trùng lặp
        let discountElement = priceDisplay.querySelector('.discount-percentage');
        if (!discountElement) {
          discountElement = document.createElement('div');
          discountElement.className = 'discount-percentage';
          priceDisplay.appendChild(discountElement);

          // Thêm CSS cho phần tử
          discountElement.style.padding = '2px 8px';
          discountElement.style.borderRadius = '10px';
          discountElement.style.textTransform = 'capitalize';
          discountElement.style.letterSpacing = '0';
          discountElement.style.backgroundColor = '#559a27';
          discountElement.style.color = '#fff';
          discountElement.style.verticalAlign = 'middle';
          discountElement.style.fontSize = '12px';
          discountElement.style.lineHeight = '20px';
          discountElement.style.display = 'inline-block';
        }
        discountElement.textContent = `Off ${discountPercentage}% `;
      }
    }
  });

document.querySelectorAll('.cd-item-price').forEach((priceDisplay) => {
    const offerPriceElement = priceDisplay.querySelector('.cd-item-price span');
    const originalPriceElement = priceDisplay.querySelector('.cd-item-price .cd-original-price');

    if (offerPriceElement && originalPriceElement) {
        const offerPrice = parseFloat(offerPriceElement.textContent.replace(/[₹,]/g, ''));
        const originalPrice = parseFloat(originalPriceElement.textContent.replace(/[₹,]/g, ''));

        if (!isNaN(originalPrice) && !isNaN(offerPrice) && originalPrice > offerPrice) {
            const discountAmount = originalPrice - offerPrice;
            const discountPercentage = Math.round((discountAmount / originalPrice) * 100); // Làm tròn số nguyên

            // Kiểm tra xem đã có phần tử giảm giá chưa, tránh tạo trùng lặp
            let discountElement = priceDisplay.querySelector('.discount-percentage');
            if (!discountElement) {
                priceDisplay.innerHTML += `
                    <div style="width: 100px"> <div class="discount-percentage" style="padding: 2px 8px;
                        border-radius: 10px;
                        text-transform: capitalize;letter-spacing: 0px;
                        background-color: rgb(85, 154, 39);
                        color: rgb(255, 255, 255);
                        font-size: 12px;line-height: 20px;
                        display: inline-block;width: fit-content;">
                        Off ${discountPercentage}%
                    </div>
                  </div>`;
            }
        }
    }
});
 
document.querySelectorAll('.cd-buy-button').forEach((button) => {
  if (!button.classList.contains('modified')) {
    // Thêm chữ "ADD" trước nội dung của button
    button.innerHTML = `<span style="margin-right: 5px; font-size: 14px; font-weight: bold;">ADD</span> ${button.innerHTML}`;

    // Đánh dấu button đã được chỉnh sửa để tránh thêm nhiều lần
    button.classList.add('modified');
  }
});


}, 1000);

// const interval = setInterval(() => {
//     const targetElement = document.querySelector(".cd-carousel-details .cd-product-title-href");
//     const sizeInfoElement = document.querySelector(".cd-opus-size-info");

//     if(sizeInfoElement) return;
  
//     if (targetElement) {
//         const newParagraph = document.createElement("p");
//         newParagraph.textContent = "Size: 3 inch";
        
//         // Check if the class already exists before adding it
//         if (!newParagraph.classList.contains('cd-opus-size-info')) {
//             newParagraph.classList.add('cd-opus-size-info');
//         }

//         // Check if the next sibling is a <p> tag to prevent duplicates
//         // if (!targetElement.nextElementSibling || targetElement.nextElementSibling.tagName !== "P") {
//         //     targetElement.insertAdjacentElement("afterend", newParagraph);
//         // }

//         targetElement.insertAdjacentElement("afterend", newParagraph);

//         // clearInterval(interval);
//     }
// }, 1000);